// extracted by mini-css-extract-plugin
module.exports = {"selected-dropdown":"styles-module__selected-dropdown___A7vl4"};